import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';
import {
  header,
  layout,
  previewCard,
  cardHead,
  phone,
  phoneScreen,
  phoneEmpty,
  listCard,
} from 'styles/preview';

const { color, radius } = theme;

const dirtyBadge = (isDirty: boolean): CSSObject => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  height: 28,
  padding: '0 10px',
  borderRadius: radius.pill,
  fontSize: 12,
  fontWeight: 600,
  color: isDirty ? color.mainOrange : color.success,
  background: isDirty ? '#FFF1EB' : color.successBg,
  '::before': {
    content: '""',
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: 'currentColor',
  },
});

const empty: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  padding: '56px 16px',
  border: `1.5px dashed ${color.grey200}`,
  borderRadius: radius.lg,
  textAlign: 'center',
  color: color.textMuted,
  fontSize: 14,
  lineHeight: 1.5,
  svg: { color: color.grey300 },
  strong: {
    display: 'block',
    fontSize: 15,
    fontWeight: 700,
    color: color.text,
  },
};

const hint: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 12,
  color: color.textMuted,
};

const headerActions: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
};

const previewSheet: CSSObject = {
  height: '70dvh',
  margin: '0 -20px',
};

export {
  header,
  dirtyBadge,
  layout,
  previewCard,
  cardHead,
  phone,
  phoneScreen,
  phoneEmpty,
  listCard,
  empty,
  hint,
  headerActions,
  previewSheet,
};
